module.exports = __webpack_public_path__ + "static/media/civilized-coffee.448d01c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/civilized-coffee.png
// module id = 192
// module chunks = 0